import { Box, Text } from '@wix/design-system';

import { MessageSender } from '../MessageSender';

import css from './index.module.scss';

type ChatMessageProps = {
  message: string;
};

export const ChatMessage = ({ message }: ChatMessageProps) => (
  <Box direction="vertical" gap="2" className={css.chatMessageContainer}>
    <MessageSender />
    <Box className={css.message}>
      <Text size="medium">{message}</Text>
    </Box>
  </Box>
);
